// src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';

console.log('[INIT] Starting React application...');

const container = document.getElementById('root');
console.log('[INIT] Root container:', container);

if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
  console.log('[INIT] Application rendered to DOM ✅');
} else {
  console.error('[INIT] Could not find root container in index.html!');
}
